
 <div >
   <div >
          <div class="header">
            <div class="rowFix" >
              <div class="col-md">
                <h3>{{'DASHBOARD.TITLE' | translate}}</h3>
              </div>
              <div >
                  <p-dropdown
                    class="dv-dropdown"
                    selectId="year"
                    [options]="yearList"
                    [(ngModel)]="selectedYear"
                    [autoDisplayFirst]="false"
                    placeholder="ปี"
                    (onChange)="changeYear()"
                  >
                  </p-dropdown>
              </div>
            </div>
          </div>

      <div class="box-parent scrollable" style="height: calc(100vh - 2.25rem - 150px);">
        <canvas id="signing-counter-bar-chart">{{ charts_signing_counter_bar_stacked }}</canvas>
      </div>
   </div>

</div>



// WEBPACK FOOTER //
// /opt/app/src/app/features/dashboard/dashboard-document/dashboard-document.component.html